export const baseApi = "https://api.asmpavia.smarteco.dev.emberware.it/wp-json/ee/v1"
